import apiClient from "./apiClient"; // Asegúrate de que la ruta es correcta

const mailsEndpoint = "/mails";

export const sendAdsToContact = async (form) => {
  // Se reemplaza fetch por apiClient.post.
  // Axios convierte 'form' a JSON automáticamente.
  return apiClient
    .post(`${mailsEndpoint}/sendAdsToContact`, form)
    .then((res) => res.data);
};

export const sendAdToContacts = async (form) => {
  return apiClient
    .post(`${mailsEndpoint}/sendAdToContacts`, form)
    .then((res) => res.data);
};
